<template>
  <v-container fill-height fluid class="container">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="6" class="text-center">
        <v-overlay
          :absolute="absolute"
          color="#ffffff"
          :opacity="opacity"
          :value="loader"
        >
          <v-progress-circular :size="70" :width="9" color="#4fc1d3" light indeterminate transition="fade-transition"></v-progress-circular>
        </v-overlay>

        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="registrationStatus === 'error'">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Errore</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            {{message}}
          </v-card-text>
        </v-card>
        <v-card class="mx-auto mt-n12" style="width: 90%" tile flat v-if="registrationStatus === 'success'">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Successo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            Grazie di esserti registrato su Donapp
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiService from '../../services'

export default {
  watch: {
    loading (val) {
      val && setTimeout(() => {
        this.loader = false
      }, 1600)
    }
  },
  data () {
    return {
      absolute: true,
      opacity: 1,
      loading: false,
      loader: true,
      message: '',
      registrationStatus: null
    }
  },

  mounted () {
    // this.verifyQrcode(this.$route.params.npoToken)
    this.confirmNpo(this.$route.params.npoToken)
  },

  methods: {
    confirmNpo (npoToken) {
      let data = {
        npoToken: npoToken
      }
      apiService
        .confirmNpo(data)
        .then(response => {
          setTimeout(() => {
            this.registrationStatus = 'success'
            this.loading = true
            console.log(response)
          }, 2000)
        })
        .catch(error => {
          this.registrationStatus = 'error'
          this.message = error.response.data.message
          this.loading = true
        })
    }
  }
}
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 0;
}
</style>
